import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=60ca4428&scoped=true&"
import script from "./LoginHeader.vue?vue&type=script&lang=ts&"
export * from "./LoginHeader.vue?vue&type=script&lang=ts&"
import style1 from "./LoginHeader.vue?vue&type=style&index=1&id=60ca4428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca4428",
  null
  
)

export default component.exports